import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Select,
  Button,
  Switch,
  Typography,
  Tooltip,
  InputNumber,
  Row,
  Col,
} from "antd";
import styled from "styled-components";
import { citiesByState, states } from "../dummyData/states&cities";
import { CloseCircleFilled } from "@ant-design/icons";
import { createBuyerForm, createSellerForm } from "../api/formsAPI";

const { Option } = Select;

const Container = styled.div`
  margin: 0 auto;
  width: 80vw;
  padding: 20px;
  background-color: #fff;

  @media (max-width: 1100px) {
    width: 100vw;
  }
`;

const FormContainer = styled.div`
  margin: 0 auto;
  width: "100%";
  padding: 20px;
`;

const FormTitle = styled.h1`
  text-align: center;
  margin-bottom: 20px;
`;

const FormButtonWrapper = styled.div`
  margin-top: 50px;
  display: flex;
  justify-content: center;
`;

const FormToggleWrapper = styled.div`
  text-align: center;
  margin-bottom: 20px;
`;

const TextContainer = styled.div`
  margin-bottom: 20px;
`;

const FieldContainer = styled.div`
  width: 100%;
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
`;

const FormsCol = styled(Col)`
  width: 49%;

  @media (max-width: 1100px) {
    width: 100%;
  }
`;

const SellerBuyerForm = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [isBuyerForm, setIsBuyerForm] = useState(true);
  const [amenities, setAmenities] = useState([]);
  const [selectedStates, setSelectedStates] = useState([]);

  const { Title, Paragraph } = Typography;

  const onFinish = async (values) => {
    setLoading(true);
    // Handle form submission logic here
    const formValues = {
      ...values,
      amenities: {
        others: amenities,
        bathroom: values.bathroom,
        bedroom: values.bedroom,
      },
    };

    delete formValues.bathroom;
    delete formValues.bedroom;

    let createdFormData;
    if (isBuyerForm) {
      createdFormData = await createBuyerForm(formValues);
    } else {
      createdFormData = await createSellerForm(formValues);
    }

    console.log(createdFormData);
    setLoading(false);
  };

  const toggleForm = () => {
    setIsBuyerForm(!isBuyerForm);
  };

  const handleFormReset = () => {
    form.resetFields();
    setAmenities([]);
  };

  const handleStateChange = (selectedStates) => {
    setSelectedStates(selectedStates);
  };

  const handleAddAmenity = () => {
    setAmenities([...amenities, ""]);
  };

  const handleAmenityChange = (index, value) => {
    const updatedAmenities = [...amenities];
    updatedAmenities[index] = value;
    setAmenities(updatedAmenities);
  };

  const handleRemoveAmenity = (index) => {
    const updatedAmenities = [...amenities];
    updatedAmenities.splice(index, 1);
    setAmenities(updatedAmenities);
  };

  const propertyTypes = [
    "Agriculture Land",
    "Apartment",
    "Bungalow",
    "Bungalow Lot Land",
    "Corner Lot",
    "Double Storey Bungalow",
    "Double Storey Semi D",
    "Double Storey Shoplot",
    "Double Storey Terrace",
    "Residential Land",
    "Semi D Cluster",
    "Semi Detached",
    "Single Storey 1½ Terrace",
    "Single Storey Bungalow",
    "Single Storey Semi D",
    "Single Storey Shoplot",
    "Single Storey Terrace",
    "Single Storey Terrace Endlot",
    "Three Storey Bungalow",
    "Three Storey Shoplot",
  ];

  useEffect(() => {
    console.log(form.getFieldValue("states"));
  }, [form.getFieldValue("states")]);

  return (
    <Container>
      <FormContainer>
        <TextContainer>
          <Typography>
            <Title level={3}>Selamat Datang</Title>
            <Paragraph>
              Terima kasih kerana memilih untuk mengisi borang kami. Kami
              menghargai masa dan usaha anda dalam menyediakan maklumat yang
              diperlukan. Kami adalah pakar dalam mengendalikan hartanah. Jika
              anda mempunyai sebarang pertanyaan atau memerlukan bantuan, sila
              hubungi kami terus melalui WhatsApp. Kami sedia membantu!
              <br />
              <br />
              Borang ini akan memberitahu ejen kami. Sila lengkapkan butiran
              mengenai permintaan anda. Kami akan membantu anda dengan secepat
              yang mungkin.
            </Paragraph>
          </Typography>
        </TextContainer>
        <FormToggleWrapper>
          <Switch
            checked={isBuyerForm}
            onChange={toggleForm}
            checkedChildren="Pembeli"
            unCheckedChildren="Penjual"
          />
        </FormToggleWrapper>
        <FormTitle>
          {isBuyerForm ? "Borang Pembeli" : "Borang Penjual"}
        </FormTitle>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          initialValues={{ propertyType: "house", status: "jual" }}
        >
          {/* Common fields for both forms */}
          <Form.Item
            name="fullName"
            label="Nama Penuh"
            rules={[
              { required: true, message: "Sila masukkan nama penuh anda" },
            ]}
          >
            <Input
              type="text"
              placeholder="E.g. Muhammad Zamran Bin Syahidan"
            />
          </Form.Item>
          <FieldContainer>
            <Row
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                gap: "10px",
              }}
            >
              <FormsCol>
                <Form.Item
                  name="phone"
                  label="Nombor Telefon"
                  rules={[
                    {
                      required: true,
                      message: "Sila masukkan nombor telefon anda",
                    },
                  ]}
                >
                  <Input type="tel" placeholder="E.g. 0123456789" />
                </Form.Item>
              </FormsCol>
              <FormsCol>
                <Form.Item
                  name="email"
                  label="E-mel"
                  rules={[
                    { required: true, message: "Sila masukkan e-mel anda" },
                    { type: "email", message: "Sila masukkan e-mel yang sah" },
                  ]}
                >
                  <Input type="email" placeholder="E.g. example@example.com" />
                </Form.Item>
              </FormsCol>
            </Row>
          </FieldContainer>
          {isBuyerForm ? (
            <>
              <Form.Item
                name="states"
                label="Negeri"
                rules={[{ required: true, message: "Sila pilih negeri" }]}
              >
                <Select
                  mode="tags"
                  placeholder="Pilih negeri"
                  onChange={handleStateChange}
                >
                  {states.map((state) => (
                    <Option key={state} value={state}>
                      {state}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                name="cities"
                label="Bandar"
                rules={[{ required: true, message: "Sila pilih bandar" }]}
              >
                <Select mode="tags" placeholder="Pilih bandar">
                  {selectedStates?.map((state) =>
                    citiesByState[state].map((city) => (
                      <Option key={city} value={city}>
                        {city}
                      </Option>
                    ))
                  )}
                </Select>
              </Form.Item>
              <Form.Item
                name="price"
                label="Harga"
                rules={[{ required: true, message: "Sila masukkan harga" }]}
              >
                <Input type="number" placeholder="E.g. 2000" />
              </Form.Item>
              <Form.Item
                name="propertyDetails"
                label="Butiran Hartanah"
                rules={[
                  {
                    required: false,
                    message: "Sila masukkan butiran hartanah",
                  },
                ]}
              >
                <Input.TextArea rows={4} />
              </Form.Item>
            </>
          ) : (
            <>
              <Form.Item
                name="location"
                label="Lokasi"
                rules={[
                  { required: true, message: "Sila masukkan lokasi anda" },
                ]}
              >
                <Input
                  type="text"
                  placeholder="Address Line 1, Address Line 2, Postal Code City, State Country"
                />
              </Form.Item>
              <FieldContainer>
                <Row
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "10px",
                  }}
                >
                  <FormsCol>
                    <Form.Item
                      name="price"
                      label="Anggaran Harga (RM)"
                      rules={[
                        { required: true, message: "Sila masukkan harga" },
                      ]}
                    >
                      <Input type="text" placeholder="E.g. 300000" />
                    </Form.Item>
                  </FormsCol>
                  <FormsCol>
                    <Form.Item
                      name="propertySize"
                      label="Keluasan Tanah (meter persegi)"
                      rules={[
                        {
                          required: true,
                          message: "Sila masukkan keluasan tanah anda",
                        },
                      ]}
                    >
                      <Input type="number" placeholder="E.g. 5000" />
                    </Form.Item>
                  </FormsCol>
                </Row>
              </FieldContainer>
              <FieldContainer>
                <Row
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "10px",
                  }}
                >
                  <FormsCol>
                    <Form.Item
                      name="propertyType"
                      label="Jenis Hartanah"
                      rules={[
                        {
                          required: true,
                          message: "Sila pilih jenis hartanah",
                        },
                      ]}
                    >
                      <Select>
                        {propertyTypes.map((type) => (
                          <Option key={type} value={type}>
                            {type}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </FormsCol>
                  <FormsCol>
                    <Form.Item
                      name="status"
                      label="Status"
                      rules={[
                        { required: true, message: "Sila pilih status urusan" },
                      ]}
                    >
                      <Select defaultValue="Something">
                        <Option value="jual">Jual</Option>
                        <Option value="sewa">Sewa</Option>
                      </Select>
                    </Form.Item>
                  </FormsCol>
                </Row>
              </FieldContainer>
              <FieldContainer>
                <Row
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "10px",
                  }}
                >
                  <FormsCol>
                    <Form.Item label="Bilik Mandi" name="bathroom">
                      <Input placeholder="E.g. 3" type="number" min={1} />
                    </Form.Item>
                  </FormsCol>
                  <FormsCol>
                    <Form.Item label="Bilik Tidur" name="bedroom">
                      <Input placeholder="E.g. 3" type="number" min={1} />
                    </Form.Item>
                  </FormsCol>
                </Row>
              </FieldContainer>

              <Form.Item
                name="amenities"
                label="Kemudahan"
                rules={[
                  {
                    // required: true,
                    message: "Sila masukkan kemudahan hartanah",
                  },
                ]}
              >
                {amenities.map((amenity, index) => (
                  <div key={index} style={{ display: "flex" }}>
                    <Input
                      value={amenity}
                      onChange={(e) =>
                        handleAmenityChange(index, e.target.value)
                      }
                      placeholder="Masukkan kemudahan hartanah"
                      suffix={
                        <Tooltip title="Diklik untuk memusnahkan kemudahan">
                          <CloseCircleFilled
                            onClick={() => handleRemoveAmenity(index)}
                          />
                        </Tooltip>
                      }
                    />
                  </div>
                ))}
                <Button type="dashed" onClick={handleAddAmenity} block>
                  Tambah Kemudahan
                </Button>
              </Form.Item>
              <Form.Item
                name="extraNotes"
                label="Nota Tambahan"
                rules={[{ required: false }]}
              >
                <Input.TextArea rows={4} />
              </Form.Item>
            </>
          )}
          <Form.Item>
            <FormButtonWrapper>
              <Button type="primary" htmlType="submit" loading={loading}>
                Hantar
              </Button>
              <Button
                type="default"
                onClick={handleFormReset}
                style={{ marginLeft: 8 }}
              >
                Reset
              </Button>
            </FormButtonWrapper>
          </Form.Item>
        </Form>
      </FormContainer>
    </Container>
  );
};

export default SellerBuyerForm;
